import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const bajajDashboardApi = createAsyncThunk(
  "bajajDashboard",
  async ({ startDate = null, endDate = null }) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    const response = await axiosInstance.get("/bajajdashboardData", {
      params,
    });
    return response.data;
  }
);

const bajajDashboardSliceSlice = createSlice({
  name: "bajajDashboard",
  initialState: {
    bajajDashboard: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(bajajDashboardApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(bajajDashboardApi.fulfilled, (state, action) => {
        state.bajajDashboard = action.payload;
        state.loading = false;
      })
      .addCase(bajajDashboardApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default bajajDashboardSliceSlice.reducer;
